"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var systemAdminApi = _interopRequireWildcard(require("@/api/systemadmin.js"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _validate = require("@/utils/validate");
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'index',
  data: function data() {
    var _this = this;
    var confirmvalidatePass = function confirmvalidatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== _this.pram.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var validatePass = function validatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else {
        if (_this.pram.confirmPassword !== '') {
          _this.$refs.pram.validateField('confirmPassword');
        }
        callback();
      }
    };
    var JavaMerInfo = JSON.parse(_jsCookie.default.get('JavaMerInfo'));
    return {
      password: '',
      JavaMerInfo: JSON.parse(_jsCookie.default.get('JavaMerInfo')),
      pram: {
        account: JavaMerInfo.account,
        password: '',
        oldPassword: '',
        confirmPassword: '',
        realName: JavaMerInfo.realName,
        id: JavaMerInfo.id
      },
      roleList: [],
      rules: {
        account: [{
          required: true,
          message: '请填写管理员账号',
          trigger: ['blur', 'change']
        }],
        oldPassword: [{
          required: true,
          message: '请填写原始密码',
          trigger: ['blur', 'change']
        }],
        password: [{
          required: true,
          validator: validatePass,
          trigger: 'blur'
        }, {
          required: true,
          min: 6,
          max: 20,
          message: '长度6-20个字符'
        }],
        confirmPassword: [{
          required: true,
          validator: confirmvalidatePass,
          trigger: ['blur', 'change']
        }],
        realName: [{
          required: true,
          message: '管理员姓名',
          trigger: ['blur', 'change']
        }]
      },
      type: 'users' //个人中心还是修改密码
    };
  },
  watch: {
    $route: function $route(to, from) {
      this.type = this.$route.params.type;
      this.tempRoute = Object.assign({}, this.$route);
      this.setTagsViewTitle();
    }
  },
  created: function created() {
    this.type = this.$route.params.type;
    this.tempRoute = Object.assign({}, this.$route);
  },
  mounted: function mounted() {
    this.setTagsViewTitle();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //设置头部标题
    setTagsViewTitle: function setTagsViewTitle() {
      var title = this.type === 'password' ? '修改密码' : '个人中心';
      var route = Object.assign({}, this.tempRoute, {
        title: "".concat(title)
      });
      this.$store.dispatch('tagsView/updateVisitedView', route);
    },
    close: function close(formName) {
      this.$refs[formName].resetFields();
    },
    handlerSubmit: (0, _validate.Debounce)(function (formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this2.type === 'password') {
            _this2.onSavePassword();
          } else {
            _this2.onSaveAccount();
          }
        } else {
          return false;
        }
      });
    }),
    //保存密码
    onSavePassword: function onSavePassword() {
      var _this3 = this;
      systemAdminApi.adminPasswordUpdate(this.pram).then(function (data) {
        _this3.$message.success('提交成功');
        _this3.$router.go(-1);
      });
    },
    //保存账号
    onSaveAccount: function onSaveAccount() {
      var _this4 = this;
      systemAdminApi.adminAccountUpdate(this.pram).then(function (data) {
        _this4.$message.success('提交成功');
        _this4.$router.go(-1);
      });
    }
  }
};